interface IIsTextSelectedOptions {
  strict?: boolean;
  targetNode?: HTMLElement | null;
}

export function isTextSelected(options?: IIsTextSelectedOptions): boolean {
  const selection = window.getSelection();

  if (
    !options?.targetNode ||
    !selection?.toString().trim() ||
    selection?.type !== 'Range' ||
    selection.rangeCount <= 0
  ) {
    return false;
  }

  if (!options?.strict) {
    return selection.containsNode(options.targetNode, true);
  }

  const range = selection.getRangeAt(0);
  const { startContainer, endContainer } = range;

  return options.targetNode.contains(startContainer) && options.targetNode.contains(endContainer);
}
